var map = {
	"./number-1.svg": 763,
	"./number-2.svg": 764,
	"./number-3.svg": 765,
	"./number-4.svg": 766,
	"./number-5.svg": 767,
	"./number-6.svg": 768,
	"./number-7.svg": 769,
	"./number-8.svg": 770,
	"./number-9.svg": 771,
	"./number-shine-1.svg": 772,
	"./number-shine-2.svg": 773,
	"./number-shine-3.svg": 774,
	"./number-shine-4.svg": 775,
	"./number-shine-5.svg": 776,
	"./number-shine-6.svg": 777,
	"./number-shine-7.svg": 778,
	"./number-shine-8.svg": 779,
	"./number-shine-9.svg": 780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 762;